<script>
export default {
    name: "ImagePlug",
};
</script>

<template>
    <div class="image-plug">P.P.S</div>
</template>

<style scoped lang="less">
.image {
    &-plug {
        width: 100%;
        min-height: 100%;
        display: flex;
        font-size: 4em;
        align-items: center;
        justify-content: center;
    }
}
</style>
